export const createBackdrop = (afterSelectorOrEl, onClick, className = 'backdrop') => {

    // Разделяем className на массив классов
    const classes = className.split(' ').filter(Boolean);

    // Проверяем, существует ли backdrop с этими классами
    const selectorAll = classes.length ? '.' + classes.join('.') : null;
    const found = selectorAll ? document.querySelector(selectorAll) : null;
    if (found) return found;

    const container = (typeof afterSelectorOrEl === 'string')
        ? document.querySelector(afterSelectorOrEl)
        : afterSelectorOrEl;

    if (!container) return null;

    const backdrop = document.createElement('div');
    classes.forEach(cls => backdrop.classList.add(cls));
    container.after(backdrop);

    requestAnimationFrame(() => backdrop.classList.add('show'));

    backdrop.addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof onClick === 'function') onClick(e);
    });

    return backdrop;
};

export const removeBackdrop = (className = 'backdrop') => {
    const el = document.querySelector('.' + className);
    if (!el) return;

    el.classList.remove('show');

    setTimeout(() => {
        el.remove();
    }, 300);
};
